import React from 'react';

function EventSelector({
    events,
    selectedEventId,
    onSelectEvent,
    selectedEvent,
    saving,
    onPublishToggle
}) {
    return (
        <>
            <div style={{ marginBottom: '1rem', textAlign: 'left' }}>
                <select
                    value={selectedEventId}
                    onChange={(e) => onSelectEvent(e.target.value)}
                    style={{
                        width: '100%',
                        padding: '0.8rem',
                        background: '#111',
                        color: '#fff',
                        border: '1px solid #333'
                    }}
                >
                    <option value="">Select event</option>
                    {events.map((event) => (
                        <option key={event._id} value={event._id}>
                            {event.title} ({event.status})
                        </option>
                    ))}
                </select>
            </div>

            {selectedEvent && (
                <div style={{ marginBottom: '1rem', textAlign: 'left' }}>
                    <div style={{ fontWeight: 'bold', marginBottom: '0.4rem' }}>
                        {selectedEvent.title}
                    </div>
                    <div style={{ color: '#999', marginBottom: '0.35rem' }}>
                        Status: {selectedEvent.status}
                    </div>
                    <div style={{ color: '#999', marginBottom: '0.75rem', fontSize: '0.9rem' }}>
                        Slug: {selectedEvent.slug}
                    </div>

                    <button type="button" onClick={onPublishToggle} disabled={saving}>
                        {selectedEvent.status === 'published' ? 'Close Event' : 'Publish Event'}
                    </button>
                </div>
            )}
        </>
    );
}

export default EventSelector;